require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-120-markdown-formatting-for-comments.json") })
        }
      }, "path---article-120-markdown-formatting-for-comments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-120-markdown-formatting-for-comments!./.cache/json/article-120-markdown-formatting-for-comments.json
// module id = 477
// module chunks = 231608221292675